import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IconHelpCircle } from '../Icon';
import Modal from '../Modal';
import { SrOnly } from '../SrOnly';
import { Header, HelpBtn, Label, Wrapper } from './wrapper';

export interface InputLabelProps {
  children: React.ReactNode;
  htmlFor?: string;
  asDiv?: boolean;
  help?: React.ReactNode;
}

const InputLabel = ({ children, htmlFor, asDiv, help }: InputLabelProps) => {
  const { t } = useTranslation(['other']);
  const [helpBox, setHelpBox] = useState(false);
  const onToggleHelpBox = () => setHelpBox(!helpBox);

  return (
    <>
      <Wrapper>
        <Header>
          {asDiv ? <Label as="div">{children}</Label> : <Label htmlFor={htmlFor}>{children}</Label>}
          {help && (
            <HelpBtn onClick={onToggleHelpBox} title={t('showDescription', { ns: 'other' })}>
              <IconHelpCircle />
              <SrOnly>{t('showDescription', { ns: 'other' })}</SrOnly>
            </HelpBtn>
          )}
        </Header>
        {help && helpBox && <Modal onClose={onToggleHelpBox}>{help}</Modal>}
      </Wrapper>
    </>
  );
};

export default InputLabel;
